import { createContext, useContext, useCallback } from 'react'
import { interpolate, resolvePluralKey, lookupString, en } from '@shared/i18n'
import type { StringKey, StringTable } from '@shared/i18n'

export const I18nContext = createContext<StringTable>(en)

/** Returns the `t` function for string lookup + interpolation. */
export function useT() {
  const strings = useContext(I18nContext)
  return useCallback((key: StringKey, vars?: Record<string, string | number>) => {
    const count = vars?.count
    const lookupKey = (
      typeof count === 'number' ? resolvePluralKey(strings, key, count) : key
    ) as StringKey
    // lookupString falls back to English then the key itself — a locale
    // missing a key degrades to English text instead of crashing
    // interpolate() on undefined (full-app ErrorBoundary).
    const template = lookupString(strings, lookupKey)
    return vars ? interpolate(template, vars) : template
  }, [strings])
}
